import styled from '@emotion/styled';

export const Tag = styled.div<{ green?: boolean }>`
    width: auto;
    height: 20px;
    border-radius: 6px;
    background-color: ${({ green, theme }) => (green ? '#DDF7E7' : theme.colors.black[200])};
    color: ${({ green, theme }) => (green ? theme.colors.success[750] : theme.colors.secondary.main)};
    font-family: Manrope !important;
    font-size: 10px;
    font-style: normal;
    line-height: 8px;
    align-content: center;
    text-align: center;
    padding: 4px;
`;
